import validate from 'validate.js'

/**
 * Add an async single validate function to ValidateJS
 * Extend ValidateJS core functionality
 */
const singleAsyncValidator = () => {
  validate.async.single = function (value, constraints, options) {
    const key = options.key || 'single'
    const newOptions = validate.extend({}, validate.single.options, options, {
      format: 'flat',
      fullMessages: false,
    })
    return validate.async({ [key]: value }, { [key]: constraints }, newOptions)
  }
}
export default singleAsyncValidator
